import React from 'react'

function ChatBig() {
  return (
    <svg
      width={96}
      height={85}
      viewBox="0 0 96 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.32} fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72 16a8 8 0 018 8v40a8 8 0 01-8 8H8a8 8 0 01-8-8V24a8 8 0 018-8h64zM52 44a4 4 0 108 0 4 4 0 00-8 0zm-16 0a4 4 0 108 0 4 4 0 00-8 0zm-12 4a4 4 0 110-8 4 4 0 010 8z"
        />
        <path d="M78 9a3 3 0 11-6 0V3a3 3 0 116 0v6zM84 21a3 3 0 013-3h6a3 3 0 110 6h-6a3 3 0 01-3-3zM85.88 14.129a3 3 0 11-4.243-4.243l4.242-4.243a3 3 0 014.243 4.243l-4.243 4.243zM36 72H12v24l24-24z" />
      </g>
    </svg>
  )
}

export default React.memo(ChatBig)
